module.exports = __webpack_public_path__ + "static/img/bp-happy.e343f46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Uphc/Uphc-pics/bp-happy.jpg
// module id = ZiaY
// module chunks = 0